/**
 * Bundle-split documents arrive from the EML splitter with a synthetic
 * filename prefix encoding the bundle index. The splitter has shipped
 * two shapes for the prefix over time:
 *
 *   _Bundle #12_LOI.pdf   (original; MDRS-20)
 *   _Bundle 12_LOI.pdf    (without the `#`; MDRS-66)
 *
 * The prefix is meaningful for backend bookkeeping (the index pins each
 * split back to the source bundle and ordering) but is noise for users
 * looking at the document list. This helper strips the prefix for
 * display while leaving the canonical name on the source record
 * untouched. The optional `#` in the regex covers both producer shapes.
 */

const BUNDLE_PREFIX = /^_Bundle #?\d+_/;

export const stripBundlePrefix = (name: string): string =>
  name.replace(BUNDLE_PREFIX, "");
